import React, { useRef, useState } from "react";

import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHEstablecimientoDel } from "services/services-mia/programa-salud/estructuras/RNHEstablecimientoDel";

export default function DeleteModal({ row, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const formikRef = useRef();

    const handleDeleteUresa = async (values) => {
        setInRequest(true);
        // id y version salen de la FILA: la lista ya los trae, asi que no hace falta
        // volver a pedir el registro solo para leer el nombre que se muestra abajo.
        const response = await RNHEstablecimientoDel(
            credentials,
            { id: row.id, version: row.version }
        );
        setInRequest(false);
        if (response.ok) {
            setSnackBarInfo({
                message: "URESA eliminada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} })
            closeModal();
        }
    }

    return (
        <Formik
            innerRef={formikRef}
            // El nombre se muestra deshabilitado, solo para confirmar que es el registro
            // correcto antes de borrarlo.
            initialValues={{
                name: row.name ?? "",
            }}
            validationSchema={
                yup.object({
                    name: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                })
            }
            onSubmit={(values) => {
                handleDeleteUresa(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            name="name"
                            labelText="Nombre"
                            readOnly
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
